import * as React from 'react';

import classNames from 'classnames';
import { Recipe } from '@src/firebase/types';
import { Header } from '@src/routes/all/components/Header/Header';
import { ViewContentArea } from '@src/routes/recipes/components/ViewContentArea';
import { ViewIngredients } from '@src/routes/recipes/components/ViewIngredients';
import { ViewStats } from '@src/routes/recipes/components/ViewStats';
import { ViewSteps } from '@src/routes/recipes/components/ViewSteps';

interface ViewRecipeProps {
  className?: string;
  recipe: Recipe;
}

/**
 * @name ViewRecipe
 * @description tbd...
 */
const ViewRecipe: React.FC<ViewRecipeProps> = (props) => {
  const { className, recipe } = props;

  // Hooks

  // Setup

  // Styles
  const componentClasses = classNames(className, 'bg-white');

  // Handlers

  // Markup

  // Life Cycle

  // Short Circuit

  return (
    <div className={componentClasses}>
      {/* Header */}
      <div className="relative pb-64 bg-gray-800">
        <Header />
        <div className="absolute inset-0">
          <img
            src={recipe.imageUrl}
            alt=""
            className="w-full h-full object-center object-cover"
          />
          <div
            className="absolute inset-0 bg-gray-200 mix-blend-multiply"
            aria-hidden="true"
          />
        </div>
        <div className="relative text-center max-w-7xl mx-auto pt-56 px-4 sm:pt-64 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-extrabold tracking-tight text-white md:text-5xl lg:text-6xl">
            {recipe.name}
          </h1>
        </div>
      </div>

      <ViewStats recipe={recipe} />
      <ViewContentArea title={recipe.name} description={recipe.description}>
        <ViewIngredients recipe={recipe} />
        <ViewSteps recipe={recipe} />
      </ViewContentArea>
    </div>
  );
};

export { ViewRecipe };
export type { ViewRecipeProps };
